import { getRemoteConfig } from "shared/store/remoteConfigs/selectors";

export const getOtpConfig = state => {
    let isEnabled = {};

    try {
        //@ts-ignore
        const { isEnabledForMobile, isEnabledForDesktop } = JSON.parse(
            getRemoteConfig(state, "otp_flow")
        );
        isEnabled = { isEnabledForMobile, isEnabledForDesktop };
    } catch (err) {
        // TODO: ADD sentry error
        isEnabled = { isEnabledForMobile: true, isEnabledForDesktop: true };
    }
    return isEnabled;
};

export const actionsForMagento = (closeOnly: boolean) => {
    try {
        if (closeOnly === true) {
            //@ts-ignore
            window.parent.closeLoginIframe();
        } else {
            //@ts-ignore
            window.parent.loginDoneViaIframe();
        }
    } catch (err) {
        window.parent.location.reload();
        // TODO: Add sentry alert
    }
};
